const changeLanguage = (language: string) => {
  localStorage.setItem('lang', language);
  // i18n.changeLanguage(language);
  window.location.reload();
};

export default changeLanguage;
